/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Stats_Per_GameInputs */

const th_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต่อเกม`)
};

const en_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per game`)
};

const ja_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1試合あたり`)
};

const zh_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场均`)
};

const es_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por partido`)
};

const pt_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por jogo`)
};

const id_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per pertandingan`)
};

const fr_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par match`)
};

const tl_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kada laro`)
};

const vi_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mỗi trận`)
};

const ko_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기당`)
};

const de_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Spiel`)
};

const ru_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за матч`)
};

const tr_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`maç başına`)
};

const it_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a partita`)
};

const pl_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`na mecz`)
};

const uk_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за матч`)
};

const hi_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति मैच`)
};

const ar_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لكل مباراة`)
};

const ms_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sepenggal perlawanan`)
};

const bn_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতি খেলায়`)
};

const zh_tw2_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場均`)
};

const zh_hk2_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場均`)
};

const ur_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فی میچ`)
};

const fa_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در هر بازی`)
};

const sw_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kwa mchezo`)
};

const nl_player_stats_per_game = /** @type {(inputs: Player_Stats_Per_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per wedstrijd`)
};

/**
* | output |
* | --- |
* | "per game" |
*
* @param {Player_Stats_Per_GameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_stats_per_game = /** @type {((inputs?: Player_Stats_Per_GameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Stats_Per_GameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_stats_per_game(inputs)
	if (locale === "ja") return ja_player_stats_per_game(inputs)
	if (locale === "zh") return zh_player_stats_per_game(inputs)
	if (locale === "es") return es_player_stats_per_game(inputs)
	if (locale === "pt") return pt_player_stats_per_game(inputs)
	if (locale === "id") return id_player_stats_per_game(inputs)
	if (locale === "fr") return fr_player_stats_per_game(inputs)
	if (locale === "tl") return tl_player_stats_per_game(inputs)
	if (locale === "vi") return vi_player_stats_per_game(inputs)
	if (locale === "ko") return ko_player_stats_per_game(inputs)
	if (locale === "de") return de_player_stats_per_game(inputs)
	if (locale === "ru") return ru_player_stats_per_game(inputs)
	if (locale === "tr") return tr_player_stats_per_game(inputs)
	if (locale === "it") return it_player_stats_per_game(inputs)
	if (locale === "pl") return pl_player_stats_per_game(inputs)
	if (locale === "uk") return uk_player_stats_per_game(inputs)
	if (locale === "hi") return hi_player_stats_per_game(inputs)
	if (locale === "ar") return ar_player_stats_per_game(inputs)
	if (locale === "ms") return ms_player_stats_per_game(inputs)
	if (locale === "bn") return bn_player_stats_per_game(inputs)
	if (locale === "zh-TW") return zh_tw2_player_stats_per_game(inputs)
	if (locale === "zh-HK") return zh_hk2_player_stats_per_game(inputs)
	if (locale === "ur") return ur_player_stats_per_game(inputs)
	if (locale === "fa") return fa_player_stats_per_game(inputs)
	if (locale === "sw") return sw_player_stats_per_game(inputs)
	if (locale === "nl") return nl_player_stats_per_game(inputs)
	return en_player_stats_per_game(inputs)
});